import { createContext } from "react";

const UserApplication=createContext()

export default UserApplication